import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sentenceCase',
})
export class SentenceCasePipe implements PipeTransform {
  transform(text: string, type?: string): string {
    if (type === 'text') {
      const line = text.split('\n');
      const excludeName = line.splice(0);

      const sentenceText = excludeName.map((item) => {
        if (item.includes('-') || item.includes('*')) {
          const firstLetterIndex = item
            .split('')
            .findIndex((letter) => /[a-z]/gm.test(letter));

          return (
            item.toLowerCase().charAt(firstLetterIndex).toUpperCase() +
            item.slice(firstLetterIndex + 1)
          );
        }

        return item.toLowerCase().charAt(0).toUpperCase() + item.slice(1);
      });
      return sentenceText.join('\n');
    }

    return text.toLowerCase().charAt(0).toUpperCase() + text.slice(1);
  }
}
